module.exports = __webpack_public_path__ + "img/kr.8fb0652c.png";